import cn from 'classnames';
import styled from 'styled-components';
import InternalLink from './InternalLink';

const StyledInternalLink = styled(InternalLink)`
  border: 1px solid transparent;
  color: #666;
  margin-bottom: -1px;
  padding: .7rem;
  text-decoration: none;

  &.active {
    background-color: #fafafa;
    border-color: rgb(66, 133, 244) #e5e5e5 #fafafa;
    color: #222;
    cursor: default;
  }
`;

const LinkComponent = ({
  active,
  children,
  className = '',
  destination,
  query,
  style,
  tooltip,
  customDataTestID,
  withProjectPath = true,
}: LinkProps): React.Element => (
  <StyledInternalLink
    customDataTestID={customDataTestID}
    className={cn(
      className,
      {
        active: active || (
          className.includes('tab') && location.pathname.includes(destination)),
      },
    ) || null} // TODO: update React, to make this better.
    style={style}
    query={query}
    title={tooltip}
    to={destination}
    withProjectPath={withProjectPath}
    >
    {children}
  </StyledInternalLink>
);

export default LinkComponent;